"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTP_CORS_MODE = exports.HTTP_CREDENTIALS = exports.HTTP_METHOD = void 0;
var HTTP_METHOD;
(function (HTTP_METHOD) {
    HTTP_METHOD["GET"] = "GET";
    HTTP_METHOD["POST"] = "POST";
    HTTP_METHOD["UPDATE"] = "UPDATE";
    HTTP_METHOD["PATCH"] = "PATCH";
    HTTP_METHOD["PUT"] = "PUT";
    HTTP_METHOD["DELETE"] = "DELETE";
    HTTP_METHOD["HEAD"] = "HEAD";
})(HTTP_METHOD = exports.HTTP_METHOD || (exports.HTTP_METHOD = {}));
var HTTP_CREDENTIALS;
(function (HTTP_CREDENTIALS) {
    HTTP_CREDENTIALS["INCLUDE"] = "include";
    HTTP_CREDENTIALS["OMIT"] = "omit";
    HTTP_CREDENTIALS["SAME_ORIGIN"] = "same-origin";
})(HTTP_CREDENTIALS = exports.HTTP_CREDENTIALS || (exports.HTTP_CREDENTIALS = {}));
var HTTP_CORS_MODE;
(function (HTTP_CORS_MODE) {
    HTTP_CORS_MODE["CORS"] = "cors";
    HTTP_CORS_MODE["NO_CORS"] = "no-cors";
    HTTP_CORS_MODE["SAME_ORIGIN"] = "same-origin";
})(HTTP_CORS_MODE = exports.HTTP_CORS_MODE || (exports.HTTP_CORS_MODE = {}));
//# sourceMappingURL=types.js.map